import { Component, OnInit, ViewChild, ElementRef, QueryList, ViewChildren } from '@angular/core';
import { NgForm, FormGroup, FormControl } from '@angular/forms';
import { Globals } from '../globals';
import { KycService } from './kyc.service';
import { KycUploadReq, KycDocUploadDtls, KycUploadRes, KycDocDetails, KycDetailsLog } from './kyc.model';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-kyc',
  templateUrl: './kyc.component.html',
  styleUrls: ['./kyc.component.css']
})
export class KycComponent implements OnInit {

  @ViewChild('kycDetailsForm') kycDetailsForm: any;
  showValidationMsgs: boolean = false;
  isLoading: boolean = false;
  showAddButton: any[] = [];
  @ViewChild('file') myInputVariable: ElementRef;
  //@ViewChild('file') myInputVariable: QueryList<ElementRef>;
  //@ViewChildren('file',  {read: ElementRef}) myInputVariable:QueryList<ElementRef>;
  kycUploadReq: KycUploadReq;
  tempDocTypeRes: any
  documentTypes: any[] = [];
  idProofs: string[] = [];
  addressProofs: string[] = [];
  kycUploadRes: KycUploadRes;
  errMsg: string;
  successMsg: string;
  kycId: string;
  kycRedirectRes: KycUploadRes;
  uploadRowErrMsg: string = "";
  isSuccess: boolean = false;

  constructor(private route: ActivatedRoute, public globals: Globals, public kycService: KycService) {
    this.kycUploadReq = new KycUploadReq();
    this.kycUploadReq.kycDetails = new KycDetailsLog();
    this.kycRedirectRes = new KycUploadRes();
    this.kycRedirectRes.kycDetails = new KycDetailsLog();
  }

  ngOnInit(): void {
    this.kycRedirectRes.kycDetails.customerType = "Individual";
    this.fetchDocumentTypes();
    this.route.queryParams.subscribe(
      (params: Params) => {
        this.kycId = params["id"];
        if(this.kycId != null && this.kycId != '' && this.kycId != undefined) {
          this.fetchKYCDetailsById();
        }
      }
    );
    this.initRequestObject();
  }

  submitKycDetails(kycDetailsForm: NgForm, isValid) {
    this.uploadRowErrMsg = "";
    if (!isValid) {
      this.showValidationMsgs = true;
      this.validateAllFields(kycDetailsForm.form);
    } else {
      let isContinue = true;
      this.kycUploadReq.kycDocUploadDetails.forEach(element => {
        if ((element.kycDocDetail.length == 0) || !element.kycDocType) {
          isContinue = false;
          this.showValidationMsgs = true;
        }
      });
      if (isContinue) {
        this.saveKycDetails();
      }
    }
  }

  saveKycDetails() {
    let count: number = this.validateAddressProof();
    if(count > 0) {
      this.isLoading = true;
      this.kycService.saveKycDetails(this.kycUploadReq).subscribe((data: KycUploadRes) => {
        this.isLoading = false;
        this.kycUploadRes = data;
        let backURL = this.globals.KYC_UPLOAD_BACK_URL+"KYCRedirectError";
        if(this.kycRedirectRes && this.kycRedirectRes.kycDetails && this.kycRedirectRes.kycDetails.returnURL) {
          backURL = this.kycRedirectRes.kycDetails.returnURL;
        }
        if (this.kycUploadRes.errMsg) {
          this.errMsg = this.kycUploadRes.errMsg;
          window.location.href = backURL+"?isKYCSuccess=false";
        } else {
          this.successMsg = this.kycUploadRes.successMsg;
          this.isSuccess = true;
          window.location.href = backURL+"?isKYCSuccess=true";
        }
      })
    } else {
      this.uploadRowErrMsg = "Please Upload ADDRESS_PROOF";
    }
  }

  validateAddressProof() {
    let count: number = 0;
    this.kycUploadReq.kycDocUploadDetails.forEach((element, index) => {
      if (element.kycProofType == 'ADDRESS_PROOF') {
        count++;
      }
    });
    return count;
  }

  initRequestObject() {
    if (this.kycUploadReq == null || this.kycUploadReq == undefined) {
      this.kycUploadReq = new KycUploadReq();
    }
    let kycDocUploadDtls = new KycDocUploadDtls();
    this.kycUploadReq.kycDocUploadDetails.push(kycDocUploadDtls);
    this.showAddButton[0] = true;
    this.documentTypes[0] = [];
  }

  onFileChange(event, index) {
    if (event.target.files && event.target.files.length > 0) {
      this.kycUploadReq.kycDocUploadDetails[index].kycDocDetail = [];
      for (let i = 0; i < event.target.files.length; i++) {
        this.kycUploadReq.kycDocUploadDetails[index].kycDocDetail.push(new KycDocDetails());
        let file = event.target.files[i];
        var extension = file.name.substr(file.name.lastIndexOf('.') + 1).toLowerCase();
        if (this.globals.IMAGE_FILE_EXTENSION.indexOf(extension) > -1 || this.globals.PDF_FILE_EXTENSION.indexOf(extension) > -1) {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = () => {
            let dataUrl = reader.result;
            let base64 = dataUrl.toString().split(",")[1];
            if (base64 && base64.length > 0) {
              this.kycUploadReq.kycDocUploadDetails[index].kycDocDetail[i].kycDoc = base64;
              this.kycUploadReq.kycDocUploadDetails[index].kycDocDetail[i].kycDocName = file.name;
            };
          }
        } else {
          this.myInputVariable.nativeElement.value = "";
          // this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Allowed File Formats are .jpg, .jpeg, .png, .gif and .pdf', life: 5000 });
          return;
        }
      }
    }
  }

  validateAllFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFields(control);
      }
    });
  }

  onAddKycDoc() {
    let count = 0;
    this.uploadRowErrMsg = "";
    this.kycUploadReq.kycDocUploadDetails.forEach((element, index) => {
      if ((!element.kycDocDetail) || (element.kycDocType == '' || element.kycDocType == null || element.kycDocType == undefined || element.kycDocDetail.length == 0)) {
        count++;
      }
    });
    if (count > 0) {
      this.uploadRowErrMsg = "Pls fill current details to upload another document";
      return;
    } else {
      let kycDocDetails = new KycDocUploadDtls();
      //Issue Fix given
      /*sessionStorage.setItem('KycUploadDetails',JSON.stringify(this.kycUploadReq));
      this.kycUploadReq = JSON.parse(sessionStorage.getItem('KycUploadDetails'));
      sessionStorage.removeItem('KycUploadDetails');*/
      this.kycUploadReq.kycDocUploadDetails.push(kycDocDetails);
      this.commonLogicToShowAddButton();
    }
  }

  indexTracker(index: number, value: any) {
    return index;
  }

  commonLogicToShowAddButton() {
    let count = this.kycUploadReq.kycDocUploadDetails.length;
    this.kycUploadReq.kycDocUploadDetails.forEach((element, index) => {
      if (index == (count - 1)) {
        this.showAddButton[index] = true;
        this.documentTypes[index] = [];
      } else {
        this.showAddButton[index] = false;;
      }
      this.setDocumentType(index);
    });
  }

  checkFileTypeAlreadySelected(idx) {
    this.uploadRowErrMsg = "";
    this.kycUploadReq.kycDocUploadDetails.forEach((element, index) => {
      if (element.kycDocType == this.kycUploadReq.kycDocUploadDetails[idx].kycDocType && element.kycProofType == this.kycUploadReq.kycDocUploadDetails[idx].kycProofType && index != idx) {
        this.kycUploadReq.kycDocUploadDetails[idx].kycDocType = "";
        $("#kycDocType_" + idx).val("");
        this.uploadRowErrMsg = "File Type Already Selected, Pls Select Another One";
        return;
      }
    });
  }

  fetchDocumentTypes() {
    this.isLoading = true;
    let body = {
      "customerType": this.kycRedirectRes.kycDetails.customerType
    }
    this.kycService.fetchDocumentTypes(body).subscribe((data: any) => {
      this.isLoading = false;
      this.tempDocTypeRes = JSON.parse(JSON.stringify(data)).documentType;
    });
  }

  fetchKYCDetailsById() {
    this.isLoading = true;
    let body = {
      "id": this.kycId
    }
    this.kycService.findKycDetailsById(body).subscribe((data: any) => {
      this.isLoading = false;
      this.kycRedirectRes = JSON.parse(JSON.stringify(data));
      if(this.kycRedirectRes.errMsg == '' || this.kycRedirectRes.errMsg == null || this.kycRedirectRes.errMsg == undefined) {
        this.kycUploadReq.kycDetails = this.kycRedirectRes.kycDetails;
        this.fetchDocumentTypes();
      } else {
        console.log("========error in fetchKYCDetailsById=========="+this.kycRedirectRes.errMsg);
      }
    });
  }

  onRemoveKycDoc(event, index) {
    this.documentTypes[index] = [];
    /*this.myInputVariable.forEach((element,itemindex) => {
      console.log("==before===="+element.nativeElement.value);
      if((index+1) == itemindex) {
        this.myInputVariable[index].nativeElement.value = element.nativeElement.value;
      }
      console.log("==after===="+element.nativeElement.value);
    });*/
    this.kycUploadReq.kycDocUploadDetails.splice(index, 1);
    this.commonLogicToShowAddButton();
  }

  setDocumentType(index) {
    this.documentTypes[index] = [];
    if(this.kycUploadReq.kycDocUploadDetails[index].kycProofType != '' && this.kycUploadReq.kycDocUploadDetails[index].kycProofType != null && this.kycUploadReq.kycDocUploadDetails[index].kycProofType != undefined) {
      for (let key in this.tempDocTypeRes) {
        if(key == this.kycUploadReq.kycDocUploadDetails[index].kycProofType) {
          this.documentTypes[index] = this.tempDocTypeRes[key];
        }
      }
    }
  }

  GoToBackPage() {
    let backURL = this.globals.KYC_UPLOAD_BACK_URL+"KYCRedirectError";
    if(this.kycRedirectRes && this.kycRedirectRes.kycDetails && this.kycRedirectRes.kycDetails.returnURL) {
      backURL = this.kycRedirectRes.kycDetails.returnURL;
    }
    window.location.href = backURL;
  }
}
